import { provinceAndCityData } from 'element-china-area-data';
import store from '@/store';

// 身份证号验证
const idCardVerify = (rule, value, callback) => {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  // const reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
  if (!reg.test(value)) {
    callback(new Error('请输入正确的身份证号'));
  } else {
    callback();
  }
};
// 手机号验证
const phoneVerify = (rule, value, callback) => {
  const reg = /^1[3456789]\d{9}$/;
  if (!reg.test(value)) {
    callback(new Error('请输入正确的手机号'));
  } else {
    callback();
  }
};
// 邮箱地址验证
const emailVerify = (rule, value, callback) => {
  // eslint-disable-next-line no-useless-escape
  const reg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
  if (!reg.test(value)) {
    callback(new Error('请输入正确的邮箱地址'));
  } else {
    callback();
  }
};
/*
*逻辑处理工具类
*/
export default {
  /**
   *
   * @param {*} code 判断按钮是否有权限的code值
   * @description 返回true/false
   */
  getButtonListRules(code) {
    return store.getters['login/buttonList'].some(i => `${i.code}` === `${code}`);
  },
  /**
   *
   * @param {Array} data 后台给的数据字典格式
   * @description 格式化后台返回的数据字典格式，方便取值
   */
  formatDictionary(data) {
    const result = {};
    data.forEach(element => {
      const sunData = {};
      element.datas.forEach(item => {
        sunData[item.value] = item.name;
      });
      result[element.category.value] = {
        name: element.category.name,
        data: sunData,
      };
    });
    return result;
  },
  /**
   *
   * @param {*} code 区域id
   * @description 省市区域解析：code转为区域中文名，传入省返回[省名字]，返回市返回[省名字,市名字]
   */
  AreaCode2Name(code) {
    if (!code) return [];
    const result = [];
    provinceAndCityData.forEach(province => {
      if (province.value === code.toString()) {
        result.push(province.label);
      }
      if (province.children) {
        province.children.forEach(city => {
          if (city.value === code.toString()) {
            result.push(province.label, city.label);
          }
        });
      }
    });
    return result;
  },
  // 输入正整数
  validNumber(number) {
    let n = number;
    n = n.replace(/[^\d]/g, '');
    return n;
  },
  // 表单验证
  idCardVerify,
  phoneVerify,
  emailVerify,
};
